module.exports = __webpack_public_path__ + "static/media/web4.8a69a133.png";